import { createContext, useContext, useState } from 'react';

const NavContext = createContext();

const NavContextProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <NavContext.Provider value={{ isActive, setIsActive }}>
      {children}
    </NavContext.Provider>
  );
};

export default NavContextProvider;

/**
 * Custom hook to access the NavContext.
 *
 * @returns {Object} The current context value for NavContext.
 */
export const UseNav = () => useContext(NavContext);
